export const COMPANY_LIST = 'COMPANY_LIST'
export const COMPANY_GET = 'COMPANY_GET'
export const COMPANY_DELETE = 'COMPANY_DELETE'
export const COMPANY_UPDATE = 'COMPANY_UPDATE'



// WEBPACK FOOTER //
// ./src/store/actions/companies.js